export default __webpack_public_path__ + "static/media/page-not-found.e4fc3174.svg";